<template>
    <RegularModal ref="modal">
        <template v-slot:title>{{ translate("admin_competitors.stats") }}</template>
        <template v-slot:body>
            <div class="columns is-mobile is-centered" v-if="!initDone">
                <LoadingSpinner2 class="has-added-margin" />
            </div>
            <div v-else class="columns">
                <div class="column is-size-5">
                    <p class="mb-2">
                        <span class="is-description">
                            <span class="icon">
                                <i class="fas fa-users"></i>
                            </span>
                            <span>{{ translate("common.total_competitors") }}:</span>
                        </span>
                        {{ stats.totalCompetitors }}
                    </p>

                    <div class="mb-2">
                        <span class="is-description">
                            <span class="icon">
                                <i class="fas fa-chart-bar"></i>
                            </span>
                            <span>{{ translate("admin_competitors.registrations_breakdown") }}</span>
                        </span>

                        <span v-if="stats.registrationBreakdownByStage.length === 0">---</span>

                        <p class="is-size-6" v-for="stageBreakDown in stats.registrationBreakdownByStage" :key="stageBreakDown.stage">
                            <span class="icon"></span>
                            <span v-if="stageBreakDown.stage === 0">
                                {{ translate("admin_competitors.outside_stage") }} {{ stageBreakDown.count }} ({{
                                    stageBreakDown.percentage
                                }}%)
                            </span>
                            <span v-else>
                                {{ translate("admin_payment.stage_number") }} #{{ stageBreakDown.stage }}: {{ stageBreakDown.count }} ({{
                                    stageBreakDown.percentage
                                }}%)
                            </span>
                        </p>
                    </div>

                    <p class="mb-2">
                        <span class="is-description">
                            <span class="icon">
                                <i class="fas fa-dollar-sign"></i>
                            </span>
                            <span>{{ translate("admin_competitors.complete_payments") }}</span>
                        </span>
                        {{ stats.totalCompletePayments }}
                        <span class="ml-1">({{ stats.percentageOfCompletePayments }}%)</span>
                    </p>

                    <p class="mb-2">
                        <span class="is-description">
                            <span class="icon">
                                <i class="fas fa-credit-card"></i>
                            </span>
                            <span>{{ translate("admin_competitors.online_payments_received") }}</span>
                        </span>
                        <span v-if="stats.onlineCompletePaymentsByCurrency.length === 0">---</span>
                        <span v-else>
                            <span v-for="(entry, index) in stats.onlineCompletePaymentsByCurrency" :key="entry.currency">
                                <span v-if="index > 0">, </span>
                                {{ entry.formattedAmount }}
                            </span>
                        </span>
                    </p>

                    <p class="mb-2">
                        <span class="is-description">
                            <span class="icon">
                                <i class="fa fa-exclamation-triangle" />
                            </span>
                            <span>{{ translate("admin_competitors.missing_payments") }}</span>
                        </span>
                        {{ stats.totalMissingPayments }}
                        <span class="ml-1">({{ stats.percentageOfMissingPayments }}%)</span>
                    </p>

                    <div class="mb-2">
                        <span class="is-description">
                            <span class="icon">
                                <i class="fas fa-hand-holding-usd"></i>
                            </span>
                            <span>{{ translate("admin_competitors.payments_breakdown") }}</span>
                        </span>

                        <span v-if="stats.paymentsByStage.length === 0">---</span>

                        <p class="is-size-6" v-for="stageBreakDown in stats.paymentsByStage" :key="stageBreakDown.stage">
                            <span class="icon"></span>
                            <span v-if="stageBreakDown.stage === 0">
                                {{ translate("admin_competitors.outside_stage") }} {{ stageBreakDown.count }} ({{
                                    stageBreakDown.percentage
                                }}%)
                            </span>
                            <span v-else>
                                {{ translate("admin_payment.stage_number") }} #{{ stageBreakDown.stage }}: {{ stageBreakDown.count }} ({{
                                    stageBreakDown.percentage
                                }}%)
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button class="button" @click="close">{{ translate("common.close") }}</button>
        </template>
    </RegularModal>
</template>

<script>
    import RegularModal from "../Common/RegularModal.vue";
    import apiMixin from "../Api/apiMixin";
    import errorHandlerMixin from "../Common/errorHandlerMixin";
    import translatorMixin from "../Common/translatorMixin";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";

    export default {
        name: "competitor-stats-modal",
        components: { LoadingSpinner2, RegularModal },
        mixins: [apiMixin, errorHandlerMixin, translatorMixin],
        props: ["eventId"],
        data() {
            return {
                stats: {},
                initDone: false,
            };
        },
        methods: {
            open() {
                this.initDone = false;
                this.$refs.modal.open();

                return this.registeredCompetitorsManagementApi()
                    .getCompetitorManagementStats(this.eventId)
                    .then(stats => (this.stats = stats))
                    .catch(this.handleError)
                    .finally(() => {
                        this.initDone = true;
                    });
            },
            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>

<style scoped></style>
